module.exports = __webpack_public_path__ + "static/media/get-shifts.9552cb75.png";